import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  tags: [],
  loading: false,
  error: null,
};

const skillsetTagsSlice = createSlice({
  name: "activitySkillsetTags",
  initialState,
  reducers: {
    fetchSkillsetTagsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchSkillsetTagsSuccess: (state, action) => {
      state.loading = false;
      state.tags = action.payload;
    },
    fetchSkillsetTagsError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearSkillsetTags: () => initialState,
  },
});

export const {
  fetchSkillsetTagsRequest,
  fetchSkillsetTagsSuccess,
  fetchSkillsetTagsError,
  clearSkillsetTags,
} = skillsetTagsSlice.actions;

export default skillsetTagsSlice.reducer;